import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import TextField from '@material-ui/core/TextField';
import PercentageFormat from 'app/main/components/PercentageFormat';

function PercentageField(props) {
  const { id, className, ...other } = props;

  return (
    <TextField
      fullWidth
      className={clsx(className, 'mt-8 mb-16')}
      variant="outlined"
      id={id}
      name={id}
      InputProps={{
        inputComponent: PercentageFormat
      }}
      {...other}
    />
  );
}

PercentageField.propTypes = {
  id: PropTypes.string.isRequired
};

export default PercentageField;
